"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var createUnistore_1 = require("./createUnistore");

var utils_1 = require("./utils");

function createStore(reducer, enhancer) {
  if (enhancer) {
    return enhancer(createStore)(reducer);
  }

  var isReducer = utils_1.isFn(reducer);
  var initialState = isReducer ? reducer(undefined, {}) : reducer;
  var store = createUnistore_1.default(initialState);

  function setState(action) {
    if (!action) return;
    var nextState = isReducer ? reducer(store.getState(), action) : action;
    store.setState(nextState);
  }

  return __assign({}, store, {
    setState: setState,
    dispatch: function dispatch(action) {
      setState(action);
    },
    action: function action(_action) {
      var _this = this;

      var apply = function apply(result) {
        result && _this.dispatch(result);
      };

      return function () {
        var args = [store.getState()];

        for (var i = 0; i < arguments.length; i++) {
          args.push(arguments[i]);
        }

        var ret = _action.apply(this, args);

        if (ret) {
          return ret.then ? apply(ret.then()) : apply(ret);
        }
      };
    }
  });
}

exports.default = createStore;